import React from 'react'
import './DescriptionBox.css';

const DescriptionBox = () => {
  return (
      <div className='DescriptionBox'>
        <div className="descriptionbox-navigator">
            <div className="descriptionbox-nav-box">Description</div>
            <div className="descriptionbox-nav-box fade">Reviews (122)</div>
        </div>
        <div className="descriptionbox-description">
            <p>
                Lorem ipsum, dolor sit amet consectetur adipisicing elit. Expedita temporibus doloremque ea repudiandae vel. Harum alias ab, dolor facere repellendus, labore dolores hic unde nobis nostrum blanditiis. Quo voluptatibus, earum sapiente quis architecto cupiditate voluptatum tempora repellat veniam maxime nam magnam laborum autem optio dolore debitis quam molestiae sequi consequatur vitae? Neque natus dolores et ipsum omnis? Sunt, eligendi quasi?
               
            </p>
              <p>
                  Lorem ipsum dolor sit amet consectetur adipisicing elit. Alias rerum asperiores iure delectus vel praesentium doloribus minima aspernatur modi reiciendis vitae, rem, a sunt possimus non earum quas consequatur odit sint? Temporibus impedit, nobis consectetur, voluptatibus voluptates cumque dolorum non ut odio molestiae molestias aspernatur! Tempore accusantium laudantium ipsam facilis voluptatem at obcaecati eum cupiditate consequuntur. Molestiae porro hic facere in omnis ducimus natus ullam iste, blanditiis animi accusamus molestias?
              </p>
        </div>
      </div>
  )
}

export default DescriptionBox